import type { RangeFormatter } from '../../types';

export const metersFormatter: RangeFormatter = (value) => {
  if (Array.isArray(value)) {
    return `${value[0]} m - ${value[1]} m`;
  }

  return '';
};

export default metersFormatter;
